import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ConsultCriteriaService} from '../../../../services/apiServices/business/consult-criteria.service';
import {ConsultCriteria} from '../../../../model/consult-criteria';
import {TranslateService} from '@ngx-translate/core';
import {RowStatus} from '../../../../model/row-status';
import {CustomTableSaverService} from '../../../../services/storage/custom-table-saver.service';
import {Subject} from 'rxjs';
import {User} from '../../../../model/user';
import {AuthenticationService} from '../../../../services/apiServices/security/authentication.service';
import {CommonService} from '../../../../services/apiServices/business/common.service';

/**
 * regex that handleChangeOfSelectFold criteria modification
 */
const regex = '[.].*';

/**
 * handleChangeOfSelectFold search results and dispatch of those results in data display components
 */
@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class SearchResultComponent implements OnInit {
  /**
   * list of results that have erl type
   */
  public erlList;
  /**
   * list of results that have Discarded erl type
   */
  public discardedErlList;

  public activeTabView = 0;
  /**
   * Number of erl elements
   */
  public numberErlElements: number;
  /**
   * Number of Discarded erl elements
   */
  public numberDiscardedErlElements: number;
  /**
   * list of results that were processed
   */
  public processedList;
  /**
   * list of results that were processed
   */
  public plannedList;

  /**
   * Number of processed elements
   */
  public numberOfProcessedElements: number;
  /**
   * Number of planned elements
   */
  public numberOfPlannedElements: number;

  /**
   * list of results that were discarded
   */
  public discardedList;

  /**
   * Number of discarded elements
   */
  public numberOfDiscardedElements: number;
  /**
   * list of results that failed
   */
  public failingList;

  /**
   * Number of failed elements
   * Usefull not to take length because the list could be modified (add elements)
   */
  public numberOfFailedElements: number;

  /**
   * list of pending element
   */
  public waitingList;

  /**
   * Number of waiting elements
   * Useful not to take length because the list could be modified (add elements)
   */
  public numberOfWaitingElements: number;

  /**
   * Number of elements
   * Useful not to take length because the list could be modified (add elements)
   */
  public totalNumberOfElements: number;


  /**
   * depositColumns to display results
   */
  public columns;
  public erlColumns;

  /**
   *  message display when there's no error on request
   */
  private successMessage;

  /**
   * title of message display when there's no error on request
   */
  private successTitle;
  private motifTitle;

  /**
   *  message display when there's not result for the request
   */
  private emptyMessage;

  /**
   * title of message ddisplay when there's not result for the request
   */
  private emptyTitle;

  /**
   * selected fold of p-table
   */
  public selectedFold;

  /**
   * title for CFE KO
   */
  public cfeKo;


  /**
   * title for cfe ok
   */
  public cfeOk;

  /**
   *  title for cfe AR
   */
  public cfeAR;
  public cfeEnquttePLAT;
  public cfeReponsePLAT;
  public cfeReponsePLATTitle;
  public cfeHISTO;

  /**
   *  title for cfe PND
   */
  public cfePND;

  /**
   * translated pnd causes
   */

  public showErlTab;
  public foldListReady: Subject<boolean>;
  public currentUser: User;

  public selectedFolds: Array<any> = [];
  public selectionType:'single' | 'multiple';

  @ViewChild('app_folds_success', { static: false } ) app_folds_success;
  @ViewChild('app_folds_discard', { static: false } ) app_folds_discard;
  @ViewChild('app_folds_fail', { static: false } ) app_folds_fail;
  @ViewChild('app_folds_wait', { static: false } ) app_folds_wait;
  @ViewChild('app_folds_erl', { static: false } ) app_folds_erl;
  @ViewChild('app_folds_discarded_erl', { static: false } ) app_folds_discarded_erl;
  /**
   *
   * @param {ConsultCriteriaService} consultService - here to get consult criterias and results
   * @param {TranslateService} translate - handleChangeOfSelectFold translation of requests results message
   * @param commonService
   * @param {CustomTableSaverService} customTableSaverService - handle customTable
   * @param {AuthenticationService} authService - handle aythentication service
   */
  constructor(private  consultService: ConsultCriteriaService, private translate: TranslateService, private commonService: CommonService,
              private customTableSaverService: CustomTableSaverService, private authService: AuthenticationService) {
    this.foldListReady = new Subject();
    this.processedList = [];
    this.plannedList = [];
    this.discardedList = [];
    this.failingList = [];
    this.waitingList = [];
    this.erlList = [];
    this.discardedErlList = [];
  }

  /**
   *
   * @param selectedFolds - the selectFoldOutput ton transmit to other components
   */
  public handleChangeOfSelectFold(selectedFolds: any) {
    if (this.selectionType === 'single') {
      this.selectedFolds = [selectedFolds];
    }
    else {
      this.selectedFolds = selectedFolds;
    }
    if (this.selectedFolds) {
      if (this.selectedFolds.length === 1) {
        this.selectedFold = this.selectedFolds[0];

      }
      else {
        this.selectedFold = null;
      }
    }
  }

  public handleTabChange( ): void {
    this.app_folds_success.pdt_fold_list.selection = null;
    this.app_folds_discard.pdt_fold_list.selection = null;
    this.app_folds_fail.pdt_fold_list.selection = null;
    this.app_folds_wait.pdt_fold_list.selection = null;

    if ( this.app_folds_erl ) {
      this.app_folds_erl.pdt_fold_list.selection = null;
      this.app_folds_discarded_erl.pdt_fold_list.selection = null;
    }

    this.selectedFolds = null;
  }

  /**
   * obtain translation from TranslateService
   */
  private getTradForComponent(): void {
    this.translate.get('FOLDS.LIST_COMPONENT.MOTIFS_TITLE').subscribe((title: string) => {
      this.motifTitle = title;
    });
    this.translate.get('TOASTER.SUCCESS_MESSAGE_TITLE').subscribe((title: string) => {
      this.successTitle = title;
    });
    this.translate.get('TOASTER.SUCESS_REQUEST_OK').subscribe((message: string) => {
      this.successMessage = message;
    });
    this.translate.get('TOASTER.WARNING_MESSAGE_TITLE').subscribe((title: string) => {
      this.emptyTitle = title;
    });
    this.translate.get('TOASTER.REQUEST_NO_RESULT').subscribe((message: string) => {
      this.emptyMessage = message;
    });
    this.translate.get('FOLDS.LIST_COMPONENT.CFE_KO').subscribe((message: string) => {
      this.cfeKo = message;
    });
    this.translate.get('FOLDS.LIST_COMPONENT.CFE_OK').subscribe((message: string) => {
      this.cfeOk = message;
    });
    this.translate.get('FOLDS.LIST_COMPONENT.CFE_AR').subscribe((message: string) => {
      this.cfeAR = message;
    });
    this.translate.get('FOLDS.LIST_COMPONENT.CFE_HISTO').subscribe((message: string) => {
      this.cfeHISTO = message;
    });
    this.translate.get('FOLDS.LIST_COMPONENT.CFE_EN_PLAT').subscribe((message: string) => {
      this.cfeEnquttePLAT = message;
    });
    this.translate.get('FOLDS.LIST_COMPONENT.CFE_RESP_PLAT').subscribe((message: string) => {
      this.cfeReponsePLAT = message;
    });
    this.translate.get('FOLDS.LIST_COMPONENT.CFE_RESP_TITLE').subscribe((message: string) => {
      this.cfeReponsePLATTitle = message;
    });
    this.translate.get('FOLDS.LIST_COMPONENT.CFE_PND').subscribe((message: string) => {
      this.cfePND = message;
    });
  }
  public getMotifPnd(motif): string {
    if (
      motif === '0' || motif === '1' || motif === '2' || motif === '3' ||
      motif === '4' || motif === '5' || motif === '6' || motif === '7' ||
      motif === '8' || motif === '9' || motif === '10' || motif === '11'
    ) {
      return this.translate.instant('FOLDS.LIST_COMPONENT.MOTIFS_' + motif);
    }
    else {
      return this.translate.instant('FOLDS.LIST_COMPONENT.MOTIFS_0');
    }
  }
  /**
   *
   * handleChangeOfSelectFold the column build! /_!_\ String Operations (using the regex on top) so that all criterias can match results
   * Moreover, it'll build headers adding a prefix if they need translations (and translateService handle the trad)
   * @param {ConsultCriteria[]} criterias - the list of criterias given by the back to consult datas
   */
  private buildColumns(criterias: ConsultCriteria[]): void {
    this.erlColumns = [
      {field: 'erlId', header: 'ERL.FIELD_HEADER.ID', width: 80},
      {field: 'userId', header: 'ERL.FIELD_HEADER.USER_ID', width: 100},
      {field: 'statusText', header: 'ERL.FIELD_HEADER.STATUS', width: 100},
      {field: 'subject', header: 'ERL.FIELD_HEADER.SUBJECT', width: 120},
      {field: 'senderLabel', header: 'ERL.FIELD_HEADER.SENDER'},
      {field: 'recipientLabel', header: 'ERL.FIELD_HEADER.RECIPIENT'},
    ];
    this.columns = [];
    const columnsFromStorageToAdd = [];
    const columnsFromCriteriasToAdd = [];

    for (const criteria of criterias) {

      if (criteria.sStorageType === 'BDD' || criteria.sStorageType === 'OBJ') {

        let correspondingPart = (new RegExp(regex).exec(criteria.sStorageName)[0]);
        correspondingPart = correspondingPart.substr(1, correspondingPart.length);

        let header;
        if (!(criteria.sNameId && criteria.sNameId.includes('persoField'))) {
          header = 'LABEL.GIVEN.BY.BACK.' + criteria.sLibI18n;
        }
        else {
          header = criteria.sLibI18n;
        }

        if (this.customTableSaverService.criteriaIsPresentAsColumn(correspondingPart)) {
          // valid columns that are in storage (only those who match criterias)
          columnsFromStorageToAdd.push(this.customTableSaverService.getColumnwithId(correspondingPart));
        } else {
          // criterias that are not present in storage
          columnsFromCriteriasToAdd.push({field: correspondingPart, header: header});
        }
      }
    }
    // reorder columns from storage using sort on indexes
    columnsFromStorageToAdd.sort(function (col1, col2) {
      return col1.index - col2.index;
    });

    // push columns not present in storage first (the user can find them quickly)
    for (const column of columnsFromCriteriasToAdd) {
      this.addColumn(column);
      // this.columns.push(column);
    }

    for (const column of columnsFromStorageToAdd) {
      this.addColumn(column);
      // this.columns.push(column);
    }
  }
  private addColumn(column: any) {
    if (column.field === 'sElectroArchivTrtID') {
      column.field = 'cfeStatusOrder';
    }
    this.columns.push(column);
  }
  /**
   *
   * dispatch results into their respective lists (usefull for binding --> see template)
   *
   * @param results - As Json they from the the search service
   */
  private buildResults(results): void {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    for (const fold of results.folds) {
      // archiving requested
      if ( fold.sElectroArchivTrtID  || fold.sElectroarchivtrt > 0) {
        fold.cfeStatus = 'cfeko';
        fold.cfeStatusOrder = 0;
        fold.cfeStatusTitle = this.cfeKo;
      }
      // archiving done
      if (fold.dCfeArchiveDate) {
        fold.cfeStatus = 'cfeok';
        fold.cfeStatusOrder = 1;
        fold.cfeStatusTitle = this.cfeOk;
      }

      // HISTO returned
      if (fold.datehisto) {
        fold.cfeStatus = 'cfehisto';
        fold.cfeStatusOrder = 2;
        fold.cfeStatusTitle = this.cfeHISTO;
      }
      // PLAT enquette
      if (fold.dateplat) {
        fold.cfeStatus = 'cfenplat';
        fold.cfeStatusOrder = 3;
        fold.cfeStatusTitle = this.cfeEnquttePLAT;
      }
      // PLAT reponse
      if (fold.reponseplat) {
        fold.cfeStatus = 'cfrpplat';
        fold.cfeStatusOrder = 4;
        if (fold.statutplat){
          fold.cfeStatusTitle = this.cfeReponsePLAT + (fold.statutplat ? '.<br>' + this.cfeReponsePLATTitle + ': ' + fold.statutplat : '');
          if (["Infructueux","Pli Non Distribué", "Reexpédition", "Aucun Suivi", "Adresse mal renseignée", "Code postal vide", "CODE POSTAL NON RECONNU PAR NOTRE SI" , "CODE POSTAL ABSENT", "CODE POSTAL ERRONE", "Preuve de distribution non restituable au client", "Document non trouvÃ© dans le SI", "Document non trouvé dans le SI", "INTRAITABLE PAS D ADRESSE NI PAYS", "ProblÃ¨me SI demande Ã  refaire en Ã©grenÃ©e", "Problème SI demande à refaire en égrenée", "Pas d'entrÃ©e dans le rÃ©seau postal", "Pas d'entrée dans le réseau postal", "Pli Non DistribuÃ©", "RÃ©expÃ©dition", "Rejet Objet stocké par Libourne", "Rejet Objet stockÃ© par Libourne", "Rejet Raison sociale destinataire et/ou Nom destinataire non renseigné", "Rejet Adresse mal renseignée", "Pli non envoyé", "Rejet Réexpédition", "donnée non conforme ou incomplète" ].includes(fold.statutplat) ){
            fold.cfeStatus = "cfrpplatInf";
            fold.cfeStatusOrder = 5;
          }

          else if (["Signature FACTEO", "Attestation", "Preuve de Distribution"].includes(fold.statutplat)) {
            fold.cfeStatus = "cfrpplatAtt";
            fold.cfeStatusOrder = 6;
          }
          else if (["SERVICE CLIENT LIBOURNE", "Demande doublon", "Recherches complémentaires", "Recherches complÃ©mentaires", "Objet dÃ©stockÃ© Libourne", "Objet déstocké Libourne", "Objet mis à  disposition / Instance", "Objet mis Ã  disposition / Instance"].includes(fold.statutplat)){
            fold.cfeStatus = "cfrpplatRec";
            fold.cfeStatusOrder = 7;
          }
          else if (["International", "Instance au pays destinataire", "Rejet Code postal international", "Pli mÃ©tropole", "Pli métropole", "Demande sur un pli etranger, mais concerne la France"].includes(fold.statutplat)){
            fold.cfeStatus = "cfrpplatInt";
            fold.cfeStatusOrder = 8;
          }
        }


      }
      // AR returned
      if (fold.sSentARDate) {
        fold.cfeStatus = 'cfear';
        fold.cfeStatusOrder = 9;
        fold.cfeStatusTitle = this.cfeAR;
      }
      // pnd
      if (fold.datepnd && (fold.sElectroArchivTrtID  || fold.sElectroarchivtrt > 0) ) {
        let pndMotif = '';
        if (fold.motifpnd) {
          pndMotif = this.getMotifPnd(fold.motifpnd);
        }
        fold.motifText = pndMotif;
        fold.cfeStatus = 'cfepnd';
        fold.cfeStatusOrder = 10;
        fold.cfeStatusTitle = this.cfePND + '.  <br>' + this.motifTitle + ': ' + pndMotif;
      }
      else if (fold.datepnd && !(fold.sElectroArchivTrtID  || fold.sElectroarchivtrt > 0) ){
        let pndMotif = '';
        if (fold.motifpnd) {
          pndMotif = this.getMotifPnd(fold.motifpnd);
        }
        fold.motifText = pndMotif;
        fold.cfeStatus = 'pnd';
        fold.cfeStatusOrder = 11;
        fold.cfeStatusTitle = this.cfePND + '.  <br>' + this.motifTitle + ': ' + pndMotif;
      }
      if (fold.rawStatus === RowStatus.PROCESSED) {
        if (fold.delayedsenddate !== undefined && fold.delayedsenddate >= today) {
          this.plannedList.push(fold);
          this.numberOfPlannedElements++;
        }
        else {
          this.processedList.push(fold);
          this.numberOfProcessedElements++;
        }
      } else if (fold.rawStatus === RowStatus.DISCARDED_LEGACY || fold.rawStatus === RowStatus.DISCARDED) {
        this.discardedList.push(fold);
        this.numberOfDiscardedElements++;
      } else if (fold.rawStatus === RowStatus.FAILED_LEGACY || fold.rawStatus === RowStatus.FAILED) {
        this.failingList.push((fold));
        this.numberOfFailedElements++;
      } else if (fold.rawStatus === RowStatus.WAITING) {
        this.numberOfWaitingElements++;
        this.waitingList.push(fold);
      }
      this.totalNumberOfElements++;
    }

    if (results.erlFolds && results.erlFolds.length > 0) {
      for (const erlFold of results.erlFolds) {
        if (erlFold.rawStatus === RowStatus.DISCARDED_LEGACY || erlFold.rawStatus === RowStatus.DISCARDED) {
          this.discardedErlList.push(erlFold);
          this.numberDiscardedErlElements++;
        } else {
          this.erlList.push(erlFold);
          this.numberErlElements++;
        }
      }
    }
    else {
      this.numberErlElements = 0;
      this.numberDiscardedErlElements = 0;
    }

    this.totalNumberOfElements = this.totalNumberOfElements + this.numberErlElements;
    this.commonService.addToast({life: 3000,
      severity: 'success',
      summary: this.successTitle,
      detail: this.successMessage
    });
    this.consultService.foldListReady.next(true);
  }


  /**
   * handleChangeOfSelectFold subscription to consultService
   */
  public ngOnInit(): void {
    this.currentUser = this.authService.getCurrentUser();
    this.showErlTab = this.currentUser.permissions.webTabLre.available;
    /*if (this.currentUser.admin) {
      this.selectionType = 'multiple';
    }
    else {
      this.selectionType = 'single';
    }*/
    this.selectionType = 'multiple';
    this.setNumberOfResultsToZero();
    this.consultService.activeTabEvent.subscribe( index => {
      this.activeTabView = index;
    });
    this.consultService.selectFoldEvent.subscribe( serialSent => {
      for (const fold of this.processedList) {
        const toTest = + fold.serialSent;
        if (serialSent === toTest) {
          setTimeout(() => {
            this.selectedFolds = [fold];
          }, 100);
          return;
        }
      }
      for (const fold of this.discardedList) {
        const toTest = + fold.serialSent;
        if (serialSent === toTest) {
          this.selectedFolds = [fold];
          return;
        }
      }
      for (const fold of this.failingList) {
        const toTest = + fold.serialSent;
        if (serialSent === toTest) {
          this.selectedFolds = [fold];
          return;
        }
      }
      for (const fold of this.waitingList) {
        const toTest = + fold.serialSent;
        if (serialSent === toTest) {
          this.selectedFolds = [fold];
          return;
        }
      }
    });
    this.consultService.exposedCriterias.subscribe(criterias => {
      this.buildColumns(criterias);
    });

    this.consultService.exposeJsonFolds.subscribe(results => {
      this.erlList = [];
      this.discardedErlList = [];
      this.processedList = [];
      this.plannedList = [];
      this.discardedList = [];
      this.failingList = [];
      this.waitingList = [];
      this.selectedFolds = [];
      this.setNumberOfResultsToZero();
      this.totalNumberOfElements = 0;

      if (results.datas) {
        this.buildResults(results.datas);
      } else {
        this.commonService.addToast({life: 3000, severity: 'warn', summary: this.emptyTitle, detail: this.emptyMessage});
      }

    });

    this.customTableSaverService.customFoldTableSubject.subscribe(columns => {
      // maybe it'll need to be changed after back-office connexion
      this.columns = columns;
    });

    this.getTradForComponent();
  }

  private setNumberOfResultsToZero(): void {
    this.numberErlElements = 0;
    this.numberDiscardedErlElements = 0;
    this.numberOfFailedElements = 0;
    this.numberOfWaitingElements = 0;
    this.numberOfDiscardedElements = 0;
    this.numberOfProcessedElements = 0;
    this.numberOfPlannedElements = 0;
  }
}
